module.exports = __webpack_public_path__ + "static/media/About-Us_1440x961.eb36a7d7.jpg";